var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEtcIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2024 3.55565L16.4665 0.35694C18.5376 -0.902984 20.9078 1.46728 19.6479 3.53839L16.4492 8.80246C16.0005 9.53885 16.0005 10.4651 16.4492 11.2072L19.6479 16.4713C20.9078 18.5424 18.5376 20.9127 16.4665 19.6528L11.2024 16.4541C10.466 16.0053 9.53975 16.0053 8.79761 16.4541L3.53354 19.6528C1.46243 20.9127 -0.907836 18.5424 0.352088 16.4713L3.5508 11.2072C3.99954 10.4709 3.99954 9.54461 3.5508 8.80246L0.352088 3.53839C-0.907836 1.46728 1.46243 -0.902984 3.53354 0.35694L8.79761 3.55565C9.534 4.00439 10.4602 4.00439 11.2024 3.55565Z",
    fill: "#FEE92B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtcIcon);
export default __webpack_public_path__ + "static/media/etc_Icon.c3d04b28c223e2bf603589705d1386d1.svg";
export { ForwardRef as ReactComponent };